import { Fragment } from 'react';
import { useRouter } from 'next/router';
import Link from 'next/link';
import { useForm, FormProvider } from 'react-hook-form';
import { CATALOGUE_CATEGORIES } from 'graphql/queries';
import getLinkPath from 'utils/getLinkPath';
import getCategoryId from 'utils/getCategoryId';
import useCategoryFilter from 'hooks/products/useCategoryFilter';
import FilterType from '../../FilterType';
import CategoryFilterItem from './CategoryFilterItem';
import { useTranslation } from 'next-i18next';

export default function CategoryFilter() {
  const { t } = useTranslation();

  const router = useRouter();
  const formMethods = useForm();

  const queryParams = router.query?.kategooria;
  const categorySlug = queryParams && queryParams[0];

  const categoryId = getCategoryId(categorySlug);
  const { categories } = useCategoryFilter({
    id: [categoryId],
    query: CATALOGUE_CATEGORIES
  });

  const getProductCount = (totalCount, productCount) => {
    if (totalCount > 0) {
      return totalCount > productCount ? totalCount : productCount;
    } else return null;
  };

  return (
    <FormProvider {...formMethods}>
      {categories?.length > 0 && (
        <FilterType title={t('category.category')}>
          {categories.map(category => {
            const { name, children, product_count, products } = category;
            return (
              <Fragment key={category.url_key}>
                {product_count >= 0 && name !== 'Komplektid koos turvahälliga' && (
                  <Link href={getLinkPath(category.url_key, categorySlug)}>
                    <a>
                      <CategoryFilterItem
                        label={name}
                        name={category.url_key}
                        qty={getProductCount(
                          products?.total_count,
                          product_count
                        )}
                      />
                    </a>
                  </Link>
                )}
                {children &&
                  children.map(subcategory => {
                    const { name, product_count, products } = subcategory;
                    return (
                      <Fragment key={subcategory.url_key}>
                        {product_count > 0 && (
                          <Link
                            href={getLinkPath(
                              subcategory.url_key,
                              category.url_key,
                              categorySlug
                            )}
                          >
                            <a>
                              <CategoryFilterItem
                                label={name}
                                name={subcategory.url_key}
                                qty={getProductCount(
                                  products?.total_count,
                                  product_count
                                )}
                                subItem
                              />
                            </a>
                          </Link>
                        )}
                      </Fragment>
                    );
                  })}
              </Fragment>
            );
          })}
        </FilterType>
      )}
    </FormProvider>
  );
}
